module.exports = __webpack_public_path__ + "static/cortny_anderson-db7996a86c6543b6427f243f20a96915.jpg";